'use client';

import { observer } from 'mobx-react-lite';
import React from 'react';

import { useRepScoreStore } from '@/presentation/hooks/useStores';

interface ReputationBadgeProps {
  className?: string;
  onClick?: () => void;
}

/**
 * Displays the user's reputation score as a badge with color coding.
 * Score colors:
 * - 800+ green
 * - 700+ blue
 * - 600+ yellow
 * - 500+ orange
 * - <500 red
 */
const ReputationBadge = observer(({ className, onClick }: ReputationBadgeProps) => {
  const repScoreStore = useRepScoreStore();

  const score = repScoreStore.currentScore;
  const scoreColor = repScoreStore.getScoreColor();

  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-1 rounded-full px-3 py-1.5 text-sm font-semibold transition-transform hover:scale-105 active:scale-95 ${className ?? ''}`}
      style={{ backgroundColor: `${scoreColor}20`, color: scoreColor }}
      aria-label={`Reputation score: ${score}`}
    >
      <span>🏅</span>
      <span>{score}</span>
    </button>
  );
});

ReputationBadge.displayName = 'ReputationBadge';

export default ReputationBadge;
